export default __webpack_public_path__ + "static/media/ms_implement_icon.32de7489.svg";